import { render, staticRenderFns } from "./move-video.vue?vue&type=template&id=0e8dd158&scoped=true&"
import script from "./move-video.vue?vue&type=script&lang=js&"
export * from "./move-video.vue?vue&type=script&lang=js&"
import style0 from "./move-video.vue?vue&type=style&index=0&id=0e8dd158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8dd158",
  null
  
)

export default component.exports